import { useEffect, useRef, useState } from "react";
import { useCurrentRefinements, useRefinementList } from "react-instantsearch";
import Srcset from "../common/Srcset";
import styles from "../PLP-2.0/PlpFilter/plpFilter.module.scss";
import { attributeTitles, renderFilterLabel, filterClickHandler, getSelectedFiltersCount, handleDropdownOnFilterCategory, renderFilterByLevelType, priceRangeCollection, checkFilterHierarchy, disableFirstUl, sortSizesFilter, renderEngraveFilterLabel } from "./filters-utils"
import { PLPFiltersTracking } from "../common/Tracking";
import { colorCode } from "@/utils/constants";
import { collectionPath } from "./collection-utils";

const EngraveCustomRefinementList = (props) => {
  // Create a copy of the attributeTitles object and add your custom attribute
  const updatedAttributeTitles = {
    ...attributeTitles,
    "named_tags.Availability": "Availability",
  };
  // Find the index of "named_tags.categories.lvl2" in the updatedAttributeTitles
  const index = Object.keys(updatedAttributeTitles).indexOf("named_tags.categories.lvl2");

  // Check if the index is found, and if so, add your custom attribute after it
  if (index !== -1) {
    const keys = Object.keys(updatedAttributeTitles);
    keys.splice(index + 1, 0, "named_tags.Availability");
    keys.forEach((key) => {
      attributeTitles[key] = updatedAttributeTitles[key];
    });
  }

  const [appliedFilterCount, setAppliedFilterCount] = useState(null);
  let initialRefinement = props.initialRefinement;

  // check if the server path is "/new-arrivals"
  let isNewArrivalPage = props.serverPath.split("/")[1] === collectionPath[2] ? true : false;

  const ulRef = useRef(null);
  let level = ulRef.current?.dataset?.level;

  /**
   * gets all the items having the attributes using useRefinement hook, and showing number of items limit
   * We are showing default 20 facets per filter, but for size filter we have more than 20 so taking it from props
   */
  let { items, refine } = useRefinementList({ ...props, limit: 20 });

  useEffect(() => {
    setAppliedFilterCount(getSelectedFiltersCount(ulRef));
  });

  // get the applied filters details
  let { items: appliedFilters, refine: clearExistingRefinement } = useCurrentRefinements(props);

  // checks if the level-1 filters exist in the appliedFilters to render level-2 filter section
  const appliedFiltersContainLvl1Label = () => appliedFilters.find((elem) => elem.label === Object.keys(attributeTitles)[1]) ? true : false

  //get current window url
  const url = typeof window != "undefined" && window.location.href;
  const filterType = (attribute) => {
    switch (attribute) {
      case "named_tags.Tag1":
        case "named_tags.Tag2":
        return "Personalization";
        case "named_tags.Tag_curated":
        return "Availability";  
      default:
        return attribute;
    }
  }

  // Open next filter for cat 0 and cat 1 
  const openNextTile = (event) => {
    const parent = event.currentTarget.closest('.filter_main_item');
    const containingParent = event.currentTarget.parentNode // UL of the selected LI tag
    if (containingParent.classList.contains('cat-lvl1')) {
      // get the count of checked items inside the container UL
      const totalChecked = Array.from(containingParent.querySelectorAll('input[type="checkbox"]:checked'))
      // get the checkbox which is currently clicked
      const currentlyClickedElement = event.target.previousElementSibling

      if (totalChecked.length === 1 && totalChecked[0] === currentlyClickedElement) {
        return
      }
      else {
        parent.querySelector('.plp-filter-header').click();
      }
    }
    if (!containingParent.classList.contains('cat-lvl1')) {
      parent.querySelector('.plp-filter-header').click();
    }

    if (!parent) {
      return;
    }
    let nextNode = parent.nextSibling;
    if (!nextNode) {
      return;
    }
    if (!nextNode.classList.contains('active') && !nextNode.classList.contains('non-cat')) {
      nextNode.querySelector('.plp-filter-header').click();
    }
  }

  const getTypeByFilterAttribute = () => {
    if (props.attribute === Object.keys(attributeTitles)[0] && isNewArrivalPage) {
      return 'type'
    }
    else {
      return 'checkbox'
    }
  }

  
  // render default filter sections i.e. other than pricing & designers
  const renderDefaultFilterSection = () => {
    return items.map((singleElement, index) => {
      if((props.attribute === "named_tags.Tag1" && singleElement.label=='MORE LETTERS AVAILABLE') || (props.attribute === "named_tags.Tag2" && singleElement.label=='ENGRAVING AVAILABLE') || ( props.attribute === "named_tags.Tag_curated" && singleElement.label=='MADE TO ORDER')) {
      let disableThis = false;
      let defaultRefined = []
      if (initialRefinement) {
        defaultRefined = initialRefinement[props.attribute];
      }
      if (defaultRefined && defaultRefined.length > 0) {
        if (defaultRefined && singleElement.value === defaultRefined[0]) {
          disableThis = true;
          if (props.attribute === "named_tags.categories.lvl0") {
            if (ulRef.current) {
              disableFirstUl(ulRef.current);
            }
          }
        }
      }
      let label = renderEngraveFilterLabel(singleElement);
      return (
          <li
            key={index}
            onClick={(e) => {
              if (disableThis) return;
              if (props.attribute === Object.keys(attributeTitles)[0] || props.attribute === Object.keys(attributeTitles)[1]) {
                openNextTile(e);
              }
              filterClickHandler(singleElement, refine, props.serverRender, isNewArrivalPage, appliedFilters, clearExistingRefinement, props.attribute);
              PLPFiltersTracking(filterType(props.attribute), label, singleElement.isRefined)
            }}
          >
            <div className="custom-checkbox">
              {/* if items are of level0 then checkbox should disabled */}
              {renderFilterByLevelType(props.attribute, singleElement, getTypeByFilterAttribute(), disableThis, isNewArrivalPage)}
              <label>
                {filterType(props.attribute) == 'Color' ? (
                  <div className='color-label-outter' >
                    <div className={`${styles.color_label_inner}`} style={{ backgroundColor: colorCode.data[renderFilterLabel(props.attribute, singleElement)] }}></div>
                  </div>
                ) : (
                  ''
                )}
                <span>{label}</span>
              </label>
            </div>
          </li>
      );
      }
    })

  }

  // render filter section by its attribute
  const renderFilterSectionByFilterAttribute = (filterAttribute, filterType) => {
    return (
          
      <>{renderDefaultFilterSection(filterType)}
    </>
  )
  }




  return (
    <>
      {items?.length ?
        (
          <>
            {renderFilterSectionByFilterAttribute(props.attribute, filterType(props.attribute))}
          </>
        )
        :
        (
          <></>
        )
      }
    </>
  );
};
export default EngraveCustomRefinementList;